module.exports = __webpack_public_path__ + "static/media/details5.52afdf94.svg";